module.exports = __webpack_public_path__ + "img/sortImg1-7.67f240d2.png";